import { Input } from "@/components/ui/input";
import {
  CellProps,
  isNumberControl,
  RankedTester,
  rankWith,
} from "@jsonforms/core";
import { withJsonFormsCellProps } from "@jsonforms/react";

const toNumber = (value: string) => (value === "" ? undefined : Number(value));

export const NumberCell = (props: CellProps) => {
  const { data, id, enabled, uischema, path, handleChange } = props;

  return (
    <Input
      type="number"
      step="0.1"
      value={data ?? ""}
      onChange={(ev) => handleChange(path, toNumber(ev.target.value))}
      id={id}
      disabled={!enabled}
      autoFocus={uischema.options?.focus}
    />
  );
};

export const numberCellTester: RankedTester = rankWith(3, isNumberControl);

export default withJsonFormsCellProps(NumberCell);
